import Skelet from '../Skelet';
import css from '../../styles/modules/objects/ObjectsMapCatalogItem.module.scss';

const ObjectsMapCatalogSkeletonItem = () => {
  return (
    <div className={css.item}>
      <div className={css.itemGallery}>
        <Skelet style={{ height: '100%', borderRadius: 16, margin: 2, width: 'auto' }} />
      </div>
      <div className={css.itemData}>
        <Skelet className={css.itemPrice} height={36} maxWidth={200} />
        <Skelet className={css.itemAddress} height={21} maxWidth={240} />
        <div className={css.itemProperties}>
          <Skelet className={css.itemProperty} width={60} height={32} style={{ marginRight: 12 }} />
          <Skelet className={css.itemProperty} width={60} height={32} style={{ marginRight: 12 }} />
          <Skelet className={css.itemProperty} width={60} height={32} style={{ marginRight: 12 }} />
        </div>
        <div className={css.itemActions}>
          <Skelet height={50} style={{ borderRadius: 12, width: '100%' }} />
        </div>
      </div>
    </div>
  );
};

export default ObjectsMapCatalogSkeletonItem;
